
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/historical/cc-jl/chapter00",
      function () {
        return require("private-next-pages/en/docs/historical/cc-jl/chapter00/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/historical/cc-jl/chapter00"])
      });
    }
  